import React from 'react'
import { connectHits } from 'react-instantsearch-dom'
import { Hit, HitsProvided } from 'react-instantsearch-core'
import { HelpPageHit } from '@/components/molecules/HelpPageHit/HelpPageHit'

const CustomHelpHits: React.FC<HitsProvided<Hit> & { query?: string }> = ({ hits, query = '' }) => (
  <ul className="w-full flex flex-col mb-32">
    {hits?.map((hit: Hit) => (
      <li key={`${hit.slug ?? hit.url}`}>
        <HelpPageHit hit={hit} query={query} />
      </li>
    ))}
  </ul>
)

export const HelpHits = connectHits(CustomHelpHits)
